export const shippingLocationModel = ({
                                          name,
                                          address,
                                          address2,
                                          city,
                                          shippingLocationId,
                                          state,
                                          zipcode,
                                          isEnabled,
                                      }: Record<string, any> = {}) => ({
    name,
    address,
    address2,
    city,
    shippingLocationId,
    state,
    zipcode,
    isEnabled,

});